module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "px3 py4",
    attrs: {
      "id": "timeline-section"
    }
  }, [_c('h1', {
    staticClass: "center m0 mb3",
    domProps: {
      "innerHTML": _vm._s(_vm.content.title)
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "flex flex-wrap mt3"
  }, _vm._l((_vm.events), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "event pr2"
    }, [_c('article', {
      staticClass: "py2",
      on: {
        "click": function($event) {
          return _vm.showDescr($event, item.id)
        }
      }
    }, [_c('div', {
      staticClass: "mb1 flex justify-between"
    }, [_c('span', {
      staticClass: "h3 mb1 bold",
      domProps: {
        "innerHTML": _vm._s(_vm.formatDate(item.date))
      }
    }), _vm._v(" "), (item.body && item.body.length > 0) ? _c('span', {}, [(item.isActive) ? _c('span', {
      staticClass: "icon-size"
    }, [_vm._v("–")]) : _c('span', {
      staticClass: "blue icon-size"
    }, [_vm._v("+")])]) : _vm._e()]), _vm._v(" "), (item.location) ? _c('span', {
      staticClass: "h4 dark-grey",
      domProps: {
        "innerHTML": _vm._s(item.location)
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "h4 m0 mb1 regular",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), (item.isActive && item.body.length > 0) ? _c('div', {
      staticClass: "h5 mt3",
      domProps: {
        "innerHTML": _vm._s(item.body)
      }
    }) : _vm._e()])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-565c9288","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Timeline.vue
// module id = 124
// module chunks = 0